import styled from 'styled-components';
import { DefaultButton } from '../../../../styles/global/css/GlobalButton';
import { DefaultText } from '../../../../styles/global/css/GlobalText';
import { PrimaryColor, BorderColor, BorderColor2, SidelyBlack, SurfaceColor } from '../../../../styles/global/css/Utils';
import penUrl from 'images/ui_icon/pen_black.svg';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: ${SurfaceColor};
    height: 100%;
    padding-top: calc(100vh - 920px);
    padding-bottom: calc(100vh - 870px);
`;

const ContainerTop = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;

const AddressContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 20px;
`;

const Separator = styled.hr`
    width: 90%;
    border: 1px solid ${BorderColor2};
    background-color: ${BorderColor2};
`;

const ContainerBottom = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`;

interface TitleProps {
  marginLeft?: string
}

const Title = styled.h3<TitleProps>`
    ${DefaultText}
    margin-left: ${p => p.marginLeft ? p.marginLeft : '0px'};
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: ${SidelyBlack};
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
`;

const SummaryBlock = styled.div`
    display: flex;
    flex-direction: row;
    padding: 5px;
    background: ${SurfaceColor};
    border: 1px solid ${BorderColor2};
    box-sizing: border-box;
    border-radius: 6px;
`;

const SummaryItemBlock = styled.div`
    margin-left: 10px;
    margin-right: 10px;
    align-self: center;
    margin: 5px;
    margin-left: 20px;
    margin-right: 20px;
`;

const SummaryItemBlockTotal = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 18px;
    background: ${PrimaryColor};
    border-radius: 4px;
    margin-left: 20px;
`;

const SummaryItemTitle = styled.h4`
    ${DefaultText}
    font-size: 14px;
    line-height: 21px;
`;

interface SummaryItemValue {
  color?: string
}

const SummaryItemValue = styled.h3`
    ${DefaultText}
    color: ${p => p.color ? p.color : SidelyBlack};
    font-size: 20px;
    line-height: 30px;
    text-align: center;
`;

const FormButton = styled(DefaultButton)`
    width: 200px;
    height: 60px;
`;

const AddressBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

const EditContainer = styled.div`
    position: relative;
`;

const Area = styled.textarea`
    background: ${SurfaceColor};
    border: 1px solid ${BorderColor};
    box-sizing: border-box;
    border-radius: 6px;
    height: 150px;
    width: 350px;
    max-width: 350px;
    min-width: 250px;
    font-size: 13px;
    padding: 10px;
`;

const Edit = styled.div`
    background-image: url('${penUrl}');
    width: 15px;
    height: 15px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    position: absolute;
    left: 93%;
    top: 5%;
`;

export {
	Container,
	ContainerTop,
	ContainerBottom,
	Title,
	Row,
	SummaryBlock,
	SummaryItemBlock,
	SummaryItemTitle,
	SummaryItemValue,
	FormButton,
	AddressBlock,
	Area,
	Separator,
	SummaryItemBlockTotal,
	AddressContainer,
	Edit,
	EditContainer
};
